var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import SearchElement from "../../components/searchelement.vue";
import { isPurchasedPart, } from "../utilities/documentdialog";
let QuickActionsTableRow = class QuickActionsTableRow extends Vue {
    searchRequest(_result) { }
    openDialog() {
        return this.dialogData;
    }
    openPartCreationDialog() { }
    openDeletionDialog() {
        return this.dialogData;
    }
    get selected() { return this.dialogData.selection.length !== 0; }
    get validSelection() {
        return this.dialogData.selection.some(s => !isPurchasedPart(s));
    }
};
__decorate([
    Prop({ required: true })
], QuickActionsTableRow.prototype, "currentSearchText", void 0);
__decorate([
    Prop({ required: true })
], QuickActionsTableRow.prototype, "dialogData", void 0);
__decorate([
    Prop({ required: true })
], QuickActionsTableRow.prototype, "numberOfColumns", void 0);
__decorate([
    Prop({ required: true })
], QuickActionsTableRow.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], QuickActionsTableRow.prototype, "showPartCreationButton", void 0);
__decorate([
    Inject()
], QuickActionsTableRow.prototype, "i18n", void 0);
__decorate([
    Inject()
], QuickActionsTableRow.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], QuickActionsTableRow.prototype, "searchRequest", null);
__decorate([
    Emit()
], QuickActionsTableRow.prototype, "openDialog", null);
__decorate([
    Emit()
], QuickActionsTableRow.prototype, "openPartCreationDialog", null);
__decorate([
    Emit()
], QuickActionsTableRow.prototype, "openDeletionDialog", null);
QuickActionsTableRow = __decorate([
    Component({
        components: {
            SearchElement,
        },
        name: "QuickActionsTableRow",
    })
], QuickActionsTableRow);
export default QuickActionsTableRow;
